import SwitchUserButton from './SwitchUserButton';
import LastLoginTimeStamp from './LastLoginTimestamp';
import IntroduceToColleagueLink from './IntroduceToColleagueLink';
import ConfigureBrowserLink from './ConfigureBrowserLink';
import { useWidgetContext } from '../context/WidgetContext';

export default function ExtrasSection() {
  const { athenaOneWebSessionTimedOut, athenaOneWebSso, athenaOneParams } = useWidgetContext();

  if (athenaOneWebSso && (athenaOneParams?.BANNERTYPE === 'ERROR' || athenaOneParams?.BANNERTYPE === 'LOGOUT')) return <></>;

  return (
    <>
      {
        ( athenaOneWebSessionTimedOut || athenaOneWebSso ) ?
          <>
            <SwitchUserButton />
            <LastLoginTimeStamp />
          </>
          :
          <>
            <IntroduceToColleagueLink />
            <ConfigureBrowserLink />
          </>
      }
    </>
  );
}
